module.exports = __webpack_public_path__ + "static/media/grey_grid.cdb8db19.svg";